import {
	Heading,
	Button,
	FormControl,
	FormLabel,
	Input,
	Container,
	Text,
	Stack,
	InputGroup,
	InputLeftElement,
	Icon,
	Box,
	Divider,
	useToast,
	Image,
} from "@chakra-ui/react";
import { useContext, useRef, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Link as ReactRouterLink, useNavigate } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import { AuthContextType } from "../../contexts/AuthContextType";
import { FaRegEnvelope, FaLock } from "react-icons/fa";

export const SignIn = () => {
	const emailRef = useRef<HTMLInputElement>(null);
	const passwordRef = useRef<HTMLInputElement>(null);
	const [, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const { signIn } = useContext<AuthContextType>(AuthContext);
	const navigate = useNavigate();
	const toast = useToast();

	async function handleSubmit() {
		try {
			setError("");
			setLoading(true);
			await signIn(emailRef.current!.value, passwordRef.current!.value);
			navigate("/dashboard");
		} catch (error) {
			toast({
				title: "Login failed.",
				status: "error",
				isClosable: true,
			});
			setError((error as Error).message);
		}

		setLoading(false);
	}

	return (
		<Container
			className="d-flex align-items-center justify-content-center"
			style={{ minHeight: "100vh" }}
		>
			<Box
				width={{ base: "90%", md: "400px" }}
				bg="secondary.card"
				rounded="lg"
				p={5}
			>
				<Box pb="2">
					<Image src="logo.png" height="40px" width="auto" />
				</Box>

				<Heading marginBottom="1.5rem">Sign in</Heading>

				<Stack spacing={4} marginBottom="1rem">
					<FormControl>
						<FormLabel htmlFor="email">Email Address</FormLabel>
						<InputGroup>
							<InputLeftElement
								children={
									<Icon as={FaRegEnvelope} color="secondary.inputHelper" />
								}
							/>
							<Input
								focusBorderColor="purple.500"
								type="email"
								name="email"
								id="email"
								ref={emailRef}
								placeholder="name@example.com"
								required
							/>
						</InputGroup>
					</FormControl>

					<FormControl>
						<Stack justifyContent="space-between" isInline>
							<FormLabel htmlFor="password">Password</FormLabel>
							<ChakraLink
								as={ReactRouterLink}
								to="/reset-password"
								color="secondary.link"
								fontSize="sm"
								fontWeight="500"
							>
								Forgot Password?
							</ChakraLink>
						</Stack>
						<InputGroup>
							<InputLeftElement
								children={<Icon as={FaLock} color="secondary.inputHelper" />}
							/>
							<Input
								focusBorderColor="purple.500"
								name="password"
								id="password"
								type="password"
								autoComplete="current-password"
								placeholder="Enter your password"
								ref={passwordRef}
								required
							/>
						</InputGroup>
					</FormControl>
				</Stack>
				<Stack marginBottom="1rem">
					<Button
						type="submit"
						colorScheme="purple"
						isLoading={loading}
						onClick={handleSubmit}
					>
						Sign in
					</Button>
				</Stack>

				<Divider marginBottom="1rem" />
				<Stack>
					<Text textAlign="center" fontWeight="500">
						Don't have an account?
						<ChakraLink
							color="purple.500"
							variant="outline"
							as={ReactRouterLink}
							to="/signup"
							pl="2"
						>
							Sign up
						</ChakraLink>
					</Text>
				</Stack>
			</Box>
		</Container>
	);
};
